package ru.villawonka.app.presentation.screens.settings.compose.view

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import ru.villawonka.app.presentation.design.theme.surfaceMiddle

@Composable
fun ColumnScope.SettingsBlockView(
    content: @Composable () -> Unit
) {
    Column(
        modifier = Modifier
            .background(
                color = MaterialTheme.colors.surfaceMiddle,
                shape = RoundedCornerShape(16.dp)
            )
    ) {
        content()
    }
}